import Rate from './Rate';
export default Rate;


//////////////////
// WEBPACK FOOTER
// ./~/rc-rate/es/index.js
// module id = 1516
// module chunks = 3